<template>
  <div class="content-wrapper">
    <AsideBar />
    <div class="content-header">
      <div
        class="d-flex justify-space-between align-items-center"
        style="border-bottom: 1px solid #00000017; height: 66px"
      >
        <div class="col">
          <h1 class="m-0 text-dark">Compare Data</h1>
          <ol class="breadcrumb float-sm-left">
            <router-link tag="li" class="breadcrumb-item" :to="{ name: 'Home' }"
              >Home</router-link
            >
            <router-link
              tag="li"
              class="breadcrumb-item"
              :to="{ name: 'Dashboard' }"
              >Dashboard</router-link
            >
            <router-link
              tag="li"
              class="breadcrumb-item"
              :to="{ name: 'MainCont' }"
              >Website Dashboard</router-link
            >
            <router-link
              tag="li"
              class="breadcrumb-item"
              :to="{ name: 'More Info' }"
              >More Info</router-link
            >
            <li class="breadcrumb-item active">Compare</li>
          </ol>
        </div>
      </div>
    </div>

    <!----- compare-content ----->
    <div class="compare-content">
      <!----- comprasion-row ------->
      <div class="comprasion-row">
        <!-- <div class="card-comprasion">
          <div class="title">Data Comprasion</div>
          <div class="datepiker-row d-flex align-items-center">
            <div class="title">Date Range:</div>
            <div class="datepiker-col">
              <date-picker
                v-model="datePicker"
                type="date"
                range
                placeholder="Select date"
              ></date-picker>
            </div>
          </div>
          <div
            class="select-row d-flex justify-space-between align-items-center"
          >
            <v-subheader v-text="'Compare to:'"></v-subheader>
            <v-select label="Previous period" dense solo></v-select>
          </div>
          <div class="button-row">
            <v-btn text>Apply</v-btn>
            <v-btn text>Reset settings</v-btn>
          </div>
        </div>
        <span>OR</span> -->
        <div class="title w-100 ml-1">Domain Comparison</div>
        <div class="card-comprasion">
          <div class="d-flex flex-column">
            <div class="title">Date Range:</div>
            <div class="datepiker-col ml-4">
              <date-picker
                v-model="datePicker"
                :disabled="loading"
                type="date"
                range
                placeholder="Select date"
              ></date-picker>
            </div>
          </div>
          <!-- <div class="select-row d-flex flex-column">
            <v-subheader
              class="p-0 ml-1"
              v-text="'Compare dates:'"
            ></v-subheader>
            <v-select
              class="ml-1"
              v-model="dateForComparison"
              :items="itemsForTheSecondPeriod"
              label="Select period"
              item-text="value"
              clearable
              dense
              solo
            >
              <template #append-item>
                <div
                  tabindex="2"
                  aria-selected="false"
                  id="list-item-71-0"
                  role="option"
                  class="v-list-item v-list-item--link theme--light"
                >
                  <date-picker
                    v-model="dateForComparison"
                    type="date"
                    range
                    placeholder="Select date"
                  ></date-picker>
                </div>
              </template>
            </v-select>
          </div> -->
          <div class="select-row d-flex flex-column">
            <v-subheader class="p-0 ml-1"></v-subheader>
            <v-select
              class="ml-1"
              :items="filteredDomains"
              v-model="domainForComparison"
              :loading="loading"
              :disabled="loading"
              label="Same domain"
              item-text="url"
              item-value="id"
              clearable
              dense
              solo
            >
              <template #prepend-item>
                <v-text-field
                  label="Search by domain"
                  class="pl-4 m-0"
                  append-icon="mdi-magnify"
                  style="height: 55px !important; width: 250px !important"
                  v-model="search"
                  v-if="!loading"
                ></v-text-field>
                <div
                  tabindex="0"
                  aria-selected="false"
                  id="list-item-71-0"
                  role="option"
                  class="v-list-item v-list-item--link theme--light"
                >
                  <option :value="$route.params.id">Same domain</option>
                </div>
              </template>
              <template #item="{ item }">
                <option :value="item.id">{{ item.url }}</option>
              </template>
            </v-select>
          </div>
          <div class="button-row">
            <v-btn text @click="applySettings" :loading="loading">Apply</v-btn>
            <v-btn text @click="resetStatisticsSettings" :loading="loading"
              >Reset settings</v-btn
            >
          </div>
        </div>
      </div>

      <!----- overview-row ----->
      <div class="overview-row">
        <div class="title">Overview comparing</div>
        <div class="graph-content" style="height: 500px; padding: 19px">
          <Spinner class="loading-spinner--center" v-if="loading" />
          <ApexChart
            ref="apexChart"
            initialDataVariant="Clicks"
            @update-data-variant="handleDataVariantUpdated"
            :fileLoading="loading"
            :dataVariants="dataVariants"
            :datasets="{
              deliveries: deliveriesSeries,
              clicks: clicksSeries,
              sends: sendsSeries,
            }"
          />
        </div>
      </div>

      <!----- others-row ----->
      <div class="others-row">
        <div class="others-col-left">
          <div class="card-other-left">
            <span class="icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.97916 19.6458C8.4236 19.6458 6.9236 19.2083 5.47916 18.3333C4.03471 17.4583 2.87499 16.4583 1.99999 15.3333V17.9792H0.291656V12.2708H5.99999V13.9792H3.14582C3.85416 14.9792 4.84721 15.8854 6.12499 16.6979C7.40277 17.5104 8.68749 17.9167 9.97916 17.9167C11.0347 17.9167 12.0382 17.7153 12.9896 17.3125C13.941 16.9097 14.7778 16.3611 15.5 15.6667C16.2222 14.9722 16.8021 14.1493 17.2396 13.1979C17.6771 12.2465 17.9028 11.2222 17.9167 10.125H19.6458C19.6319 11.4583 19.3646 12.7049 18.8437 13.8646C18.3229 15.0243 17.6215 16.0347 16.7396 16.8958C15.8576 17.7569 14.8368 18.4305 13.6771 18.9167C12.5174 19.4028 11.2847 19.6458 9.97916 19.6458ZM9.27082 15.9792V14.9375C8.70138 14.7986 8.18402 14.5278 7.71874 14.125C7.25346 13.7222 6.88193 13.1667 6.60416 12.4583L7.89582 12.0208C8.0486 12.5764 8.32638 13.0069 8.72916 13.3125C9.13193 13.618 9.60416 13.7708 10.1458 13.7708C10.7153 13.7708 11.1597 13.6493 11.4792 13.4062C11.7986 13.1632 11.9583 12.8333 11.9583 12.4167C11.9583 12 11.8021 11.6458 11.4896 11.3542C11.1771 11.0625 10.625 10.75 9.83332 10.4167C8.87499 10.0417 8.16666 9.63541 7.70832 9.19791C7.24999 8.76041 7.02082 8.18054 7.02082 7.45832C7.02082 6.84721 7.21527 6.31596 7.60416 5.86457C7.99304 5.41318 8.56249 5.12499 9.31249 4.99999V4.04166H10.7083V4.99999C11.25 5.08332 11.7083 5.26388 12.0833 5.54166C12.4583 5.81943 12.7778 6.24999 13.0417 6.83332L11.8125 7.39582C11.6042 6.97916 11.3437 6.6736 11.0312 6.47916C10.7187 6.28471 10.3611 6.18749 9.95832 6.18749C9.4861 6.18749 9.1111 6.29513 8.83332 6.51041C8.55554 6.72568 8.41666 7.01388 8.41666 7.37499C8.41666 7.79166 8.58679 8.13193 8.92707 8.39582C9.26735 8.65971 9.83332 8.95832 10.625 9.29166C11.6111 9.69443 12.3125 10.1354 12.7292 10.6146C13.1458 11.0937 13.3542 11.6944 13.3542 12.4167C13.3542 12.8055 13.2917 13.1493 13.1667 13.4479C13.0417 13.7465 12.8611 14.0035 12.625 14.2187C12.3889 14.434 12.1076 14.6042 11.7812 14.7292C11.4549 14.8542 11.0833 14.9375 10.6667 14.9792V15.9792H9.27082ZM0.354157 9.87499C0.354157 8.58332 0.607629 7.35763 1.11457 6.19791C1.62152 5.03818 2.30902 4.02777 3.17707 3.16666C4.04513 2.30555 5.06596 1.62152 6.23957 1.11457C7.41318 0.607629 8.66666 0.354156 9.99999 0.354156C11.5555 0.354156 13.0625 0.795129 14.5208 1.67707C15.9792 2.55902 17.1319 3.55555 17.9792 4.66666V2.02082H19.7083V7.72916H14V6.02082H16.8542C16.1042 4.97916 15.0833 4.06249 13.7917 3.27082C12.5 2.47916 11.2361 2.08332 9.99999 2.08332C8.94443 2.08332 7.94096 2.28471 6.98957 2.68749C6.03818 3.09027 5.20138 3.63888 4.47916 4.33332C3.75693 5.02777 3.17707 5.85068 2.73957 6.80207C2.30207 7.75346 2.07638 8.77777 2.06249 9.87499H0.354157Z"
                  fill="white"
                />
              </svg>
            </span>

            <div class="title">Conversion Rate</div>
            <Spinner class="mb-4" v-if="loading" />
            <div class="value bad" v-else-if="!loading">0%</div>
            <div class="profit-vs">
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.61612 5.60254L1.11295 5.60254L1.11295 2.09937"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.12363 5.6026L5.8584 0.867837"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-bottom" v-else-if="!loading">0%</span>
              <span>vs</span>
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.41556 1.39749L5.91872 1.39749V4.90066"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.90803 1.39743L1.17327 6.13219"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-top" v-else-if="!loading">0%</span>
            </div>
          </div>
          <div class="card-other-left">
            <span class="icon">
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 5.33333C14.8194 5.33333 14.2431 5.09375 13.7708 4.61458C13.2986 4.13542 13.0625 3.55556 13.0625 2.875C13.0625 2.20833 13.2986 1.63542 13.7708 1.15625C14.2431 0.677083 14.8194 0.4375 15.5 0.4375C16.1806 0.4375 16.7604 0.677083 17.2396 1.15625C17.7188 1.63542 17.9583 2.20833 17.9583 2.875C17.9583 3.55556 17.7188 4.13542 17.2396 4.61458C16.7604 5.09375 16.1806 5.33333 15.5 5.33333ZM0.8125 18.8542V3.10417C0.8125 2.57639 1.00347 2.11458 1.38542 1.71875C1.76736 1.32292 2.22917 1.125 2.77083 1.125H11.7708C11.6181 1.43056 11.5069 1.75347 11.4375 2.09375C11.3681 2.43403 11.3542 2.77083 11.3958 3.10417C11.4097 3.45139 11.4653 3.78472 11.5625 4.10417C11.6597 4.42361 11.8056 4.72917 12 5.02083H4.66667V6.27083H13.0208C13.3958 6.50694 13.7882 6.68403 14.1979 6.80208C14.6076 6.92014 15.0417 6.97917 15.5 6.97917C16.0833 6.97917 16.6354 6.86806 17.1562 6.64583C17.6771 6.42361 18.1389 6.09028 18.5417 5.64583V13.5625C18.5417 14.0903 18.3438 14.5486 17.9479 14.9375C17.5521 15.3264 17.0903 15.5208 16.5625 15.5208H4.14583L0.8125 18.8542ZM4.66667 8.97917H14.6667V7.72917H4.66667V8.97917ZM4.66667 11.6875H11.1875V10.4375H4.66667V11.6875Z"
                  fill="white"
                />
              </svg>
            </span>

            <div class="title">Sent pushes</div>
            <Spinner class="mb-4" v-if="loading" />
            <div
              class="value"
              v-else-if="!loading"
              :style="{
                color:
                  Math.sign(sent.groupA - sent.groupB) === 1
                    ? '#43A047'
                    : '#FF5252',
              }"
            >
              {{ formatNumber(sent.groupA - sent.groupB) }}
            </div>
            <div class="profit-vs">
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.61612 5.60254L1.11295 5.60254L1.11295 2.09937"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.12363 5.6026L5.8584 0.867837"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-bottom" v-else-if="!loading">{{
                formatNumber(sent.groupA)
              }}</span>
              <span>vs</span>
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.41556 1.39749L5.91872 1.39749V4.90066"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.90803 1.39743L1.17327 6.13219"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-top" v-else-if="!loading">{{
                formatNumber(sent.groupB)
              }}</span>
            </div>
          </div>
          <div class="card-other-left">
            <span class="icon">
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.65001 1.40001L3.45834 0.208344C1.45834 1.73334 0.141677 4.08334 0.0250101 6.75001H1.69168C1.81668 4.54168 2.95001 2.60834 4.65001 1.40001V1.40001ZM14.975 6.75001H16.6417C16.5167 4.08334 15.2 1.73334 13.2083 0.208344L12.025 1.40001C13.7083 2.60834 14.85 4.54168 14.975 6.75001ZM13.3333 7.16668C13.3333 4.60834 11.9667 2.46668 9.58334 1.90001V1.33334C9.58334 0.641677 9.02501 0.0833435 8.33334 0.0833435C7.64168 0.0833435 7.08334 0.641677 7.08334 1.33334V1.90001C4.69168 2.46668 3.33334 4.60001 3.33334 7.16668V11.3333L1.66668 13V13.8333H15V13L13.3333 11.3333V7.16668ZM8.33334 16.3333C8.45001 16.3333 8.55834 16.325 8.66668 16.3C9.20834 16.1833 9.65001 15.8167 9.86668 15.3167C9.95001 15.1167 9.99168 14.9 9.99168 14.6667H6.65834C6.66668 15.5833 7.40834 16.3333 8.33334 16.3333Z"
                  fill="white"
                />
              </svg>
            </span>

            <div class="title">Delivered pushes</div>
            <Spinner class="mb-4" v-if="loading" />
            <div
              class="value"
              v-else-if="!loading"
              :style="{
                color:
                  Math.sign(delivered.groupA - delivered.groupB) === 1
                    ? '#43A047'
                    : '#FF5252',
              }"
            >
              {{ formatNumber(delivered.groupA - delivered.groupB) }}
            </div>
            <div class="profit-vs">
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.61612 5.60254L1.11295 5.60254L1.11295 2.09937"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.12363 5.6026L5.8584 0.867837"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-bottom" v-else-if="!loading">{{
                formatNumber(delivered.groupA)
              }}</span>
              <span>vs</span>
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.41556 1.39749L5.91872 1.39749V4.90066"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.90803 1.39743L1.17327 6.13219"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-top" v-else-if="!loading">{{
                formatNumber(delivered.groupB)
              }}</span>
            </div>
          </div>
          <div class="card-other-left">
            <span class="icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.87501 15.7083C8.30557 15.6806 6.98265 15.1146 5.90626 14.0104C4.82987 12.9063 4.29168 11.5695 4.29168 10C4.29168 8.40279 4.84376 7.04862 5.94793 5.93751C7.05209 4.8264 8.40279 4.27084 10 4.27084C11.5695 4.27084 12.9063 4.81598 14.0104 5.90626C15.1146 6.99654 15.6875 8.33334 15.7292 9.91668L13.9167 9.35418C13.7778 8.39584 13.3403 7.6007 12.6042 6.96876C11.8681 6.33682 11 6.02084 10 6.02084C8.8889 6.02084 7.94793 6.40626 7.17709 7.17709C6.40626 7.94793 6.02084 8.8889 6.02084 10C6.02084 11 6.33682 11.8646 6.96876 12.5938C7.6007 13.3229 8.3889 13.7639 9.33334 13.9167L9.87501 15.7083ZM10.9375 19.25C10.7847 19.2639 10.632 19.2743 10.4792 19.2813C10.3264 19.2882 10.1667 19.2917 10 19.2917C8.72223 19.2917 7.51737 19.0486 6.38543 18.5625C5.25348 18.0764 4.26737 17.4132 3.42709 16.5729C2.58682 15.7326 1.92362 14.7465 1.43751 13.6146C0.951399 12.4826 0.708344 11.2778 0.708344 10C0.708344 8.72223 0.951399 7.51737 1.43751 6.38543C1.92362 5.25348 2.58682 4.26737 3.42709 3.42709C4.26737 2.58682 5.25348 1.92362 6.38543 1.43751C7.51737 0.951399 8.72223 0.708344 10 0.708344C11.2778 0.708344 12.4826 0.951399 13.6146 1.43751C14.7465 1.92362 15.7326 2.58682 16.5729 3.42709C17.4132 4.26737 18.0764 5.25348 18.5625 6.38543C19.0486 7.51737 19.2917 8.72223 19.2917 10C19.2917 10.1667 19.2882 10.3299 19.2813 10.4896C19.2743 10.6493 19.2639 10.8056 19.25 10.9583L17.5625 10.4583V10C17.5625 7.90279 16.8264 6.11807 15.3542 4.64584C13.882 3.17362 12.0972 2.43751 10 2.43751C7.90279 2.43751 6.11807 3.17362 4.64584 4.64584C3.17362 6.11807 2.43751 7.90279 2.43751 10C2.43751 12.0972 3.17362 13.882 4.64584 15.3542C6.11807 16.8264 7.90279 17.5625 10 17.5625H10.4375L10.9375 19.25ZM17.3333 19.2292L13.6667 15.5417L12.6042 18.7292L10 10L18.7292 12.6042L15.5417 13.6667L19.2292 17.3333L17.3333 19.2292Z"
                  fill="white"
                />
              </svg>
            </span>

            <div class="title">Clicked pushes</div>
            <Spinner class="mb-4" v-if="loading" />
            <div
              class="value"
              :style="{
                color:
                  Math.sign(clicked.groupA - clicked.groupB) === 1
                    ? '#43A047'
                    : '#FF5252',
              }"
              v-else-if="!loading"
            >
              {{ formatNumber(clicked.groupA - clicked.groupB) }}
            </div>
            <div class="profit-vs">
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.61612 5.60254L1.11295 5.60254L1.11295 2.09937"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.12363 5.6026L5.8584 0.867837"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-bottom" v-else-if="!loading">{{
                formatNumber(clicked.groupA)
              }}</span>
              <span>vs</span>
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.41556 1.39749L5.91872 1.39749V4.90066"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.90803 1.39743L1.17327 6.13219"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-top" v-else-if="!loading">{{
                formatNumber(clicked.groupB)
              }}</span>
            </div>
          </div>
          <div class="card-other-left">
            <span class="icon">
              <svg
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.0208 17.6667L14.9583 16.5833L16.3125 15.1875H12.0417V13.625H16.3125L14.9375 12.25L16.0208 11.1458L19.2917 14.4167L16.0208 17.6667ZM2.77083 15.1875C2.21528 15.1875 1.75 15 1.375 14.625C1 14.25 0.8125 13.7847 0.8125 13.2292V2.77082C0.8125 2.21527 1 1.74652 1.375 1.36457C1.75 0.982629 2.21528 0.791656 2.77083 0.791656H16.5625C17.1181 0.791656 17.5868 0.982629 17.9688 1.36457C18.3507 1.74652 18.5417 2.21527 18.5417 2.77082V10.2292C18.1528 10.0208 17.7535 9.8611 17.3438 9.74999C16.934 9.63888 16.5139 9.58332 16.0833 9.58332C14.6111 9.58332 13.3611 10.0937 12.3333 11.1146C11.3056 12.1354 10.7917 13.375 10.7917 14.8333V15.1875H2.77083ZM9.66667 9.02082L16.5625 4.49999V2.77082L9.66667 7.20832L2.77083 2.77082V4.49999L9.66667 9.02082Z"
                  fill="white"
                />
              </svg>
            </span>

            <div class="title">Delivery rate</div>
            <Spinner class="mb-4" v-if="loading" />
            <div
              class="value bad"
              v-else-if="!loading"
              :style="{
                color:
                  Math.sign(
                    (
                      parseFloat(deliveryRate.groupA) -
                      parseFloat(deliveryRate.groupB)
                    ).toFixed(2)
                  ) === 1
                    ? '#43A047'
                    : '#FF5252',
              }"
            >
              {{
                (
                  parseFloat(deliveryRate.groupA) -
                  parseFloat(deliveryRate.groupB)
                ).toFixed(2)
              }}%
            </div>
            <div class="profit-vs">
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.61612 5.60254L1.11295 5.60254L1.11295 2.09937"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.12363 5.6026L5.8584 0.867837"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-bottom" v-else-if="!loading"
                >{{ deliveryRate.groupA }}%</span
              >
              <span>vs</span>
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.41556 1.39749L5.91872 1.39749V4.90066"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.90803 1.39743L1.17327 6.13219"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-top" v-else-if="!loading"
                >{{ deliveryRate.groupB }}%</span
              >
            </div>
          </div>
          <div class="card-other-left">
            <span class="icon">
              <svg
                width="15"
                height="19"
                viewBox="0 0 15 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.02084 0.5C8.14584 0.5 9.11459 0.899305 9.92709 1.69792C10.7396 2.49653 11.1458 3.45833 11.1458 4.58333C11.1458 5.29167 10.9826 5.94792 10.6563 6.55208C10.3299 7.15625 9.85418 7.64583 9.22918 8.02083V4.875C9.22918 4.23611 9.02084 3.71528 8.60418 3.3125C8.18751 2.90972 7.65973 2.70833 7.02084 2.70833C6.38195 2.70833 5.85418 2.90972 5.43751 3.3125C5.02084 3.71528 4.81251 4.23611 4.81251 4.875V8.02083C4.18751 7.61805 3.71182 7.11458 3.38543 6.51042C3.05904 5.90625 2.89584 5.26389 2.89584 4.58333C2.89584 3.45833 3.30209 2.49653 4.11459 1.69792C4.92709 0.899305 5.89584 0.5 7.02084 0.5ZM6.83334 18.8125C6.56945 18.8125 6.31598 18.7604 6.07293 18.6562C5.82987 18.5521 5.61807 18.4097 5.43751 18.2292L0.583344 13.8125L0.979177 13.25C1.18751 13 1.41668 12.8299 1.66668 12.7396C1.91668 12.6493 2.2014 12.6389 2.52084 12.7083L5.43751 13.2292V4.91667C5.43751 4.45833 5.58682 4.07986 5.88543 3.78125C6.18404 3.48264 6.56251 3.33333 7.02084 3.33333C7.47918 3.33333 7.85765 3.48264 8.15626 3.78125C8.45487 4.07986 8.60418 4.45833 8.60418 4.91667V9.5H8.66668C8.90279 9.5 9.15279 9.52431 9.41668 9.57292C9.68057 9.62153 9.93751 9.70139 10.1875 9.8125L12.9167 11C13.3472 11.1944 13.6667 11.5069 13.875 11.9375C14.0833 12.3681 14.1389 12.8264 14.0417 13.3125L13.2708 17.2917C13.1875 17.75 12.9653 18.1181 12.6042 18.3958C12.2431 18.6736 11.8264 18.8125 11.3542 18.8125H6.83334Z"
                  fill="white"
                />
              </svg>
            </span>

            <div class="title">Pushes CTR</div>
            <Spinner class="mb-4" v-if="loading" />
            <div
              class="value"
              v-else-if="!loading"
              :style="{
                color:
                  Math.sign(
                    (parseFloat(ctr.groupA) - parseFloat(ctr.groupB)).toFixed(2)
                  ) === 1
                    ? '#43A047'
                    : '#FF5252',
              }"
            >
              {{
                (parseFloat(ctr.groupA) - parseFloat(ctr.groupB)).toFixed(2)
              }}%
            </div>
            <div class="profit-vs">
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.61612 5.60254L1.11295 5.60254L1.11295 2.09937"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.12363 5.6026L5.8584 0.867837"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-bottom" v-else-if="!loading"
                >{{ ctr.groupA }}%</span
              >
              <span>vs</span>
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.41556 1.39749L5.91872 1.39749V4.90066"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.90803 1.39743L1.17327 6.13219"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-top" v-else-if="!loading"
                >{{ ctr.groupB }}%</span
              >
            </div>
          </div>
          <div class="card-other-left">
            <span class="icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.95832 14.9375L0.354156 13.7708L4.70832 6.81248L6.91666 9.39581L9.91666 4.52081L12.625 8.58331C12.2917 8.65276 11.9757 8.75692 11.6771 8.89581C11.3785 9.0347 11.0903 9.20831 10.8125 9.41665L9.99999 8.16665L7.20832 12.7291L4.95832 10.125L1.95832 14.9375ZM18.25 19.6458L15.3958 16.7916C15.118 16.9722 14.8194 17.1041 14.5 17.1875C14.1805 17.2708 13.8611 17.3125 13.5417 17.3125C12.5 17.3125 11.6111 16.9444 10.875 16.2083C10.1389 15.4722 9.77082 14.5833 9.77082 13.5416C9.77082 12.5 10.1389 11.6076 10.875 10.8646C11.6111 10.1215 12.5 9.74998 13.5417 9.74998C14.5833 9.74998 15.4722 10.1215 16.2083 10.8646C16.9444 11.6076 17.3125 12.5 17.3125 13.5416C17.3125 13.875 17.2639 14.1979 17.1667 14.5104C17.0694 14.8229 16.9444 15.125 16.7917 15.4166L19.6458 18.2291L18.25 19.6458ZM13.5417 15.3541C14.0417 15.3541 14.4687 15.1771 14.8229 14.8229C15.1771 14.4687 15.3542 14.0416 15.3542 13.5416C15.3542 13.0416 15.1771 12.6111 14.8229 12.25C14.4687 11.8889 14.0417 11.7083 13.5417 11.7083C13.0417 11.7083 12.6146 11.8889 12.2604 12.25C11.9062 12.6111 11.7292 13.0416 11.7292 13.5416C11.7292 14.0416 11.9062 14.4687 12.2604 14.8229C12.6146 15.1771 13.0417 15.3541 13.5417 15.3541ZM15.375 8.81248C15.0278 8.6597 14.6736 8.56942 14.3125 8.54165C13.9514 8.51387 13.5903 8.50692 13.2292 8.52081L18.0625 0.708313L19.6458 1.87498L15.375 8.81248Z"
                  fill="white"
                />
              </svg>
            </span>

            <div class="title">Hate rate</div>
            <Spinner class="mb-4" v-if="loading" />
            <div
              class="value"
              :style="{
                color:
                  Math.sign(
                    (
                      parseFloat(hateRate.groupA) - parseFloat(hateRate.groupB)
                    ).toFixed(2)
                  ) === 1
                    ? '#43A047'
                    : '#FF5252',
              }"
              v-else-if="!loading"
            >
              {{
                (
                  parseFloat(hateRate.groupA) - parseFloat(hateRate.groupB)
                ).toFixed(2)
              }}%
            </div>
            <div class="profit-vs">
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.61612 5.60254L1.11295 5.60254L1.11295 2.09937"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.12363 5.6026L5.8584 0.867837"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-bottom" v-else-if="!loading"
                >{{ hateRate.groupA }}%</span
              >
              <span>vs</span>
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.41556 1.39749L5.91872 1.39749V4.90066"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.90803 1.39743L1.17327 6.13219"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-top" v-else-if="!loading"
                >{{ hateRate.groupB }}%</span
              >
            </div>
          </div>
          <div class="card-other-left">
            <span class="icon">
              <svg
                width="21"
                height="12"
                viewBox="0 0 21 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.416672 11.25V9.89581C0.416672 9.27081 0.729172 8.77081 1.35417 8.39581C1.97917 8.02081 2.79167 7.83331 3.79167 7.83331H4.04167C4.11112 7.83331 4.18751 7.84026 4.27084 7.85415C4.14584 8.11804 4.04514 8.39929 3.96876 8.6979C3.89237 8.99651 3.85417 9.31248 3.85417 9.64581V11.25H0.416672ZM5.41667 11.25V9.64581C5.41667 8.6597 5.90278 7.86803 6.875 7.27081C7.84723 6.67359 9.11112 6.37498 10.6667 6.37498C12.25 6.37498 13.5208 6.67359 14.4792 7.27081C15.4375 7.86803 15.9167 8.6597 15.9167 9.64581V11.25H5.41667ZM17.4792 11.25V9.64581C17.4792 9.31248 17.4444 8.99651 17.375 8.6979C17.3056 8.39929 17.2083 8.11804 17.0833 7.85415C17.1667 7.84026 17.2465 7.83331 17.3229 7.83331H17.5417C18.5694 7.83331 19.3889 8.02081 20 8.39581C20.6111 8.77081 20.9167 9.27081 20.9167 9.89581V11.25H17.4792ZM3.79167 7.27081C3.34723 7.27081 2.96876 7.11109 2.65626 6.79165C2.34376 6.4722 2.18751 6.09026 2.18751 5.64581C2.18751 5.20137 2.34376 4.8229 2.65626 4.5104C2.96876 4.1979 3.34723 4.04165 3.79167 4.04165C4.23612 4.04165 4.61806 4.1979 4.93751 4.5104C5.25695 4.8229 5.41667 5.20831 5.41667 5.66665C5.41667 6.0972 5.26042 6.4722 4.94792 6.79165C4.63542 7.11109 4.25001 7.27081 3.79167 7.27081ZM17.5417 7.27081C17.0972 7.27081 16.7188 7.11109 16.4063 6.79165C16.0938 6.4722 15.9375 6.09026 15.9375 5.64581C15.9375 5.20137 16.0938 4.8229 16.4063 4.5104C16.7188 4.1979 17.0972 4.04165 17.5417 4.04165C17.9861 4.04165 18.3681 4.1979 18.6875 4.5104C19.0069 4.8229 19.1667 5.20831 19.1667 5.66665C19.1667 6.0972 19.0104 6.4722 18.6979 6.79165C18.3854 7.11109 18 7.27081 17.5417 7.27081ZM10.6667 5.77081C9.90278 5.77081 9.25348 5.50345 8.71876 4.96873C8.18403 4.43401 7.91667 3.7847 7.91667 3.02081C7.91667 2.24304 8.18403 1.59026 8.71876 1.06248C9.25348 0.534702 9.90278 0.270813 10.6667 0.270813C11.4444 0.270813 12.0972 0.534702 12.625 1.06248C13.1528 1.59026 13.4167 2.24304 13.4167 3.02081C13.4167 3.7847 13.1528 4.43401 12.625 4.96873C12.0972 5.50345 11.4444 5.77081 10.6667 5.77081Z"
                  fill="white"
                />
              </svg>
            </span>

            <div class="title">Patience days</div>
            <Spinner class="mb-4" v-if="loading" />
            <div
              class="value"
              :style="{
                color:
                  Math.sign(
                    (
                      parseFloat(patienceDays.groupA) -
                      parseFloat(patienceDays.groupB)
                    ).toFixed(2)
                  ) === 1
                    ? '#43A047'
                    : '#FF5252',
              }"
              v-else-if="!loading"
            >
              {{
                (
                  parseFloat(patienceDays.groupA) -
                  parseFloat(patienceDays.groupB)
                ).toFixed(2)
              }}%
            </div>
            <div class="profit-vs">
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.61612 5.60254L1.11295 5.60254L1.11295 2.09937"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.12363 5.6026L5.8584 0.867837"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-bottom" v-else-if="!loading">{{
                patienceDays.groupA
              }}</span>
              <span>vs</span>
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.41556 1.39749L5.91872 1.39749V4.90066"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.90803 1.39743L1.17327 6.13219"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-top" v-else-if="!loading">{{
                patienceDays.groupB
              }}</span>
            </div>
          </div>
          <div class="card-other-left">
            <span class="icon">
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1488_256)">
                  <path
                    d="M0.847183 15.6948L0.0585499 13.7892L8.11703 10.6391L12.337 13.6341L19.9792 12.0037L20.75 13.7892L11.2697 16.3716L7.00001 13.3334L0.847183 15.6948Z"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.0833029 12.1823V12.75H0.318246L0.0833029 12.1823ZM0.0833029 12.1135L3.52979 10.8699C3.54519 10.6369 3.58039 10.4129 3.63539 10.1979C3.71178 9.89929 3.81247 9.61804 3.93747 9.35415C3.85414 9.34026 3.77775 9.33331 3.7083 9.33331H3.4583C2.4583 9.33331 1.6458 9.52081 1.0208 9.89581C0.395803 10.2708 0.0833029 10.7708 0.0833029 11.3958V12.1135ZM5.0833 12.5676V12.75H8.42616L7.13299 11.8609L5.0833 12.5676ZM15.5833 11.2748L12.337 11.9674L8.25001 9.16665L5.23407 10.2549C5.44616 9.67071 5.88202 9.17601 6.54164 8.77081C7.51386 8.17359 8.77775 7.87498 10.3333 7.87498C11.9166 7.87498 13.1875 8.17359 14.1458 8.77081C15.1041 9.36803 15.5833 10.1597 15.5833 11.1458V11.2748ZM18.4463 12.75H20.5833V12.1679L18.4463 12.75ZM20.5833 11.7363L19.9792 10.3369L17.1414 10.9424C17.1301 10.6833 17.0968 10.4351 17.0416 10.1979C16.9722 9.89929 16.875 9.61804 16.75 9.35415C16.8333 9.34026 16.9132 9.33331 16.9896 9.33331H17.2083C18.2361 9.33331 19.0555 9.52081 19.6666 9.89581C20.2777 10.2708 20.5833 10.7708 20.5833 11.3958V11.7363ZM2.32289 8.29165C2.63539 8.61109 3.01386 8.77081 3.4583 8.77081C3.91664 8.77081 4.30205 8.61109 4.61455 8.29165C4.92705 7.9722 5.0833 7.5972 5.0833 7.16665C5.0833 6.70831 4.92358 6.3229 4.60414 6.0104C4.28469 5.6979 3.90275 5.54165 3.4583 5.54165C3.01386 5.54165 2.63539 5.6979 2.32289 6.0104C2.01039 6.3229 1.85414 6.70137 1.85414 7.14581C1.85414 7.59026 2.01039 7.9722 2.32289 8.29165ZM16.0729 8.29165C16.3854 8.61109 16.7639 8.77081 17.2083 8.77081C17.6666 8.77081 18.0521 8.61109 18.3646 8.29165C18.6771 7.9722 18.8333 7.5972 18.8333 7.16665C18.8333 6.70831 18.6736 6.3229 18.3541 6.0104C18.0347 5.6979 17.6527 5.54165 17.2083 5.54165C16.7639 5.54165 16.3854 5.6979 16.0729 6.0104C15.7604 6.3229 15.6041 6.70137 15.6041 7.14581C15.6041 7.59026 15.7604 7.9722 16.0729 8.29165ZM8.38539 6.46873C8.92011 7.00345 9.56941 7.27081 10.3333 7.27081C11.1111 7.27081 11.7639 7.00345 12.2916 6.46873C12.8194 5.93401 13.0833 5.2847 13.0833 4.52081C13.0833 3.74304 12.8194 3.09026 12.2916 2.56248C11.7639 2.0347 11.1111 1.77081 10.3333 1.77081C9.56941 1.77081 8.92011 2.0347 8.38539 2.56248C7.85066 3.09026 7.5833 3.74304 7.5833 4.52081C7.5833 5.2847 7.85066 5.93401 8.38539 6.46873Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1488_256">
                    <rect
                      width="20"
                      height="20"
                      fill="white"
                      transform="translate(0.333344)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>

            <div class="title">Subscriber LTV</div>
            <Spinner class="mb-4" v-if="loading" />
            <div
              class="value"
              :style="{
                color:
                  Math.sign(
                    (
                      parseFloat(subsLTV.groupA) - parseFloat(subsLTV.groupB)
                    ).toFixed(2)
                  ) === 1
                    ? '#43A047'
                    : '#FF5252',
              }"
              v-else-if="!loading"
            >
              {{
                (
                  parseFloat(subsLTV.groupA) - parseFloat(subsLTV.groupB)
                ).toFixed(2)
              }}%
            </div>
            <div class="profit-vs">
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.61612 5.60254L1.11295 5.60254L1.11295 2.09937"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1.12363 5.6026L5.8584 0.867837"
                    stroke="#3171B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-bottom" v-else-if="!loading">
                {{ parseFloat(subsLTV.groupA).toFixed(2) }}%</span
              >
              <span>vs</span>
              <span class="icon-arrow">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.41556 1.39749L5.91872 1.39749V4.90066"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.90803 1.39743L1.17327 6.13219"
                    stroke="#F6C344"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <Spinner class="spinner-loading--sm" v-if="loading" />
              <span class="value value-top" v-else-if="!loading">
                {{ parseFloat(subsLTV.groupB).toFixed(2) }}%</span
              >
            </div>
          </div>
        </div>
        <div class="others-col-right">
          <div class="card-other-right">
            <div class="title">Subscribers</div>
            <div class="graph-content">
              <RadialBar
                height="300px"
                refLabel="subs"
                :labels="groups"
                :datasets="subsSeries"
              />
            </div>
          </div>
          <div class="card-other-right">
            <div class="title">Unsubscribers</div>
            <div class="graph-content">
              <RadialBar
                height="300px"
                refLabel="unSubs"
                :labels="groups"
                :datasets="unsubsSeries"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Error v-if="error" />
    <Warnings v-if="warning" warningText="Select domain for comparison!" />
  </div>
</template>

<script>
import AsideBar from "./AsideBar.vue";
import ApexChart from "../../charts/ApexChart.vue";
import RadialBar from "../../charts/RadialBar.vue";
// import User from "../../apis/User";
import Statistics from "../../apis/Statistics.js";
import statistics from "../../mixins/statistics";
import DatePicker from "vue2-datepicker";
import Error from "../popUps/Error.vue";
import Warnings from "../popUps/Warnings.vue";
import Spinner from "../popUps/Spinner.vue";
import "vue2-datepicker/index.css";
import moment from "moment";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    AsideBar,
    ApexChart,
    RadialBar,
    DatePicker,
    Error,
    Warnings,
    Spinner,
  },
  mixins: [statistics],
  name: "Compare",
  data() {
    return {
      loading: false,

      domainForComparison: "",
      dateForComparison: "",
      groups: [],

      search: "",
      selectedDataVariant: "",
      dataVariants: ["Deliveries", "Clicks", "Sends"],

      itemsForTheSecondPeriod: [
        { id: 0, value: "Select period" },
        { id: 1, value: "Previous period" },
      ],

      ctr: {
        groupA: 0,
        groupB: 0,
      },
      deliveryRate: {
        groupA: 0,
        groupB: 0,
      },
      sent: {
        groupA: 0,
        groupB: 0,
      },
      delivered: {
        groupA: 0,
        groupB: 0,
      },
      clicked: {
        groupA: 0,
        groupB: 0,
      },
      patienceDays: {
        groupA: 0,
        groupB: 0,
      },
      hateRate: {
        groupA: 0,
        groupB: 0,
      },
      subsLTV: {
        groupA: 0,
        groupB: 0,
      },
    };
  },
  created() {
    this.show();
  },
  computed: {
    ...mapState({
      domains: (state) => state.domain.domains,
    }),
    ...mapGetters(["selectedDomainWebsite"]),
    filteredDomains() {
      return this.domains.filter((p) => {
        return (
          p.url.toLowerCase().indexOf(this.search.toLowerCase()) != -1 ||
          p.id == this.search
        );
      });
    },
  },
  methods: {
    ...mapActions(["show"]),
    handleDataVariantUpdated(variant) {
      this.selectedDataVariant = variant;
    },
    async applySettings() {
      this.loading = true;

      this.clicksSeries = [];
      this.sendsSeries = [];
      this.deliveriesSeries = [];

      // this.subsSeries[0] = 0;
      // this.unsubsSeries[0] = 0;
      // this.subsSeries[1] = 0;
      // this.unsubsSeries[1] = 0;

      // To compare two domains
      if (this.domainForComparison) {
        let groups = [];
        let domains = [];

        domains.push(this.domainForComparison);
        domains.push(this.$route.params.id);

        groups[0] = this.findDomain(this.$route.params.id).url.split("https://")[1];
        groups[1] = this.findDomain(this.domainForComparison).url.split("https://")[1];

        await this.compareDomains(this.datePicker, domains, groups);
      }

      queueMicrotask(() => {
        setTimeout(() => {
          this.loading = false;
        }, 2000);
      });

      // To compare two dates
      // if (typeof this.dateForComparison === "object") {
      //   this.compareDates(
      //     this.dateForComparison,
      //     this.domainForComparison || this.$route.params.id
      //   );
      // }

      // if (!this.domainForComparison && !this.dateForComparison) {
      //   this.warning = true;
      // }
    },
    resetStatisticsSettings() {
      this.$set(this, "datePicker", [
        new Date(
          moment()
            .subtract(1, "weeks")
            .format("YYYY, MM, DD")
        ),
        new Date(moment().format("YYYY, MM, DD")),
      ]);
      this.$set(this, "dateForComparison", [
        new Date(
          moment()
            .subtract(2, "weeks")
            .format("YYYY, MM, DD")
        ),
        new Date(
          moment()
            .subtract(1, "weeks")
            .format("YYYY, MM, DD")
        ),
      ]);

      this.sendsSeries = [];
      this.clicksSeries = [];
      this.deliveriesSeries = [];

      // this.subsSeries[0] = 0;
      // this.unsubsSeries[0] = 0;
      // this.subsSeries[1] = 0;
      // this.unsubsSeries[1] = 0;

      this.domainForComparison = "";
    },
    getDripStats(dateStart, dateEnd, dateRange, domains) {
      let dateTruncParams = dateRange ? `&date_trunc=${dateRange}` : "";

      return new Promise((resolve, reject) => {
        Statistics.getStatsEventsByDrips(
          `date_start=${moment(dateStart).format(
            "YYYY-MM-DD"
          )}&date_finish=${moment(dateEnd).format(
            "YYYY-MM-DD"
          )}&group_by=website_id&domain_ids=${domains.toString()}` +
            dateTruncParams
        )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSubStats(dateStart, dateEnd, domains) {
      return new Promise((resolve, reject) => {
        Statistics.getStatsBySubscribables(
          `date_start=${moment(dateStart).format(
            "YYYY-MM-DD"
          )}&date_finish=${moment(dateEnd).format(
            "YYYY-MM-DD"
          )}&domain_ids=${domains.toString()}&date_trunc=millennium&group_by=website_id`
        )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    groupStatsDataByDomain(arr) {
      let result = arr.reduce(
        (acc, curr) => {
          curr["website_id"] ===
          this.findDomain(this.$route.params.id).website_id
            ? acc[0].push(curr)
            : acc[1].push(curr);
          return acc;
        },
        [[], []]
      );
      return result;
    },
    async compareDomains(date, domains) {
      await this.getDripStats(date[0], date[1], null, domains)
        .then((response) => {
          return response.data.data;
        })
        .then((response) => {
          let group = "";

          for (let obj of response) {
            group =
              obj.website_id ===
              this.findDomain(this.$route.params.id).website_id
                ? "groupA"
                : "groupB";

            this.createIndexesForComparison(
              "ctr",
              group,
              obj,
              "push_ctr",
              true
            );

            this.createIndexesForComparison(
              "deliveryRate",
              group,
              obj,
              "delivery_rate",
              true
            );

            this.createIndexesForComparison("sent", group, obj, "sent");

            this.createIndexesForComparison(
              "delivered",
              group,
              obj,
              "delivered"
            );

            this.createIndexesForComparison("clicked", group, obj, "clicked");

            this.createIndexesForComparison(
              "hateRate",
              group,
              obj,
              "hate_rate",
              true
            );

            this.createIndexesForComparison(
              "subsLTV",
              group,
              obj,
              "subscriber_ltv",
              true
            );
          }
        });

      await this.getDripStats(date[0], date[1], "day", domains)
        .then((response) => {
          return response.data.data;
        })
        .then(async (response) => {
          let groupedArrayByUrls = this.groupStatsDataByDomain(response);

          for (let obj of groupedArrayByUrls) {
            await this.createLineChart(obj);
          }
        })
        .catch((error) => {
          this.error = error + "drips";
        });

      await this.getSubStats(date[0], date[1], domains)
        .then(async (response) => {
          for (let i = 0; i < response.data.data.length; i++) {
            await this.createIndexesForComparison(
              "patienceDays",
              response.data.data[i].website_id ===
                this.findDomain(this.$route.params.id).website_id
                ? "groupA"
                : "groupB",
              response.data.data[i],
              "avg_patient_days",
              true
            );

            await this.createRadialBar(
              new Array(response.data.data[i]),
              response.data.data[i].website_id ===
                this.findDomain(this.$route.params.id).website_id
                ? this.findDomain(this.$route.params.id).url.split("https://")[1]
                : this.selectedDomainWebsite(response.data.data[i].website_id)
                    .url.split("https://")[1],
              i
            );
          }
        })
        .catch((error) => {
          this.error = error + "subs";
        });
    },
    async compareDates(dates, domain) {
      let dripResponse = [];
      let subsResponse = [];
      let group = "";

      for (let date of dates) {
        await this.getDripStats(date[0], date[1], "day", domain)
          .then((response) => {
            dripResponse.push(response.data.data);
          })
          .catch((error) => {
            this.error = error;
          });

        this.getSubStats(date[0], date[1], domain)
          .then((response) => {
            subsResponse.push(response.data.data);
          })
          .catch((error) => {
            this.error = error;
          });
      }

      for (let [i, array] of dripResponse) {
        await this.createLineChart(array);

        group =
          array[0].url === this.findDomain(this.$route.params.id).url.split("https://")[1]
            ? "groupA"
            : "groupB";

        this.createIndexesForComparison("ctr", group, array, "push_ctr", true);
        this.createIndexesForComparison(
          "deliveryRate",
          group,
          array,
          "delivery_rate",
          true
        );
        this.createIndexesForComparison("sent", group, array, "sent");
        this.createIndexesForComparison("delivered", group, array, "delivered");
        this.createIndexesForComparison("clicked", group, array, "clicked");
        this.createIndexesForComparison(
          "hateRate",
          group,
          array,
          "hate_rate",
          true
        );
        this.createIndexesForComparison(
          "subsLTV",
          group,
          array,
          "subscriber_ltv",
          true
        );
      }

      ["The first range", "The second range"].forEach((el, i) => {
        this.createIndexesForComparison(
          "patienceDays",
          el,
          response.data.data[i],
          "avg_patient_days",
          true
        );

        this.createRadialBar(response.data.data, el, i);
      });
    },
    createLineChart(obj) {
      for (let property of ["sent", "clicked", "delivered"]) {
        switch (property) {
          case "sent":
            this.sendsSeries.push(
              this.modifyDataForCreatingCharts(
                obj,
                property,
                obj[0].website_id ===
                  this.findDomain(this.$route.params.id).website_id
                  ? this.findDomain(this.$route.params.id).url.split("https://")[1]
                  : this.selectedDomainWebsite(obj[0].website_id).url.split("https://")[1]
              )
            );
            break;
          case "clicked":
            this.clicksSeries.push(
              this.modifyDataForCreatingCharts(
                obj,
                property,
                obj[0].website_id ===
                  this.findDomain(this.$route.params.id).website_id
                  ? this.findDomain(this.$route.params.id).url.split("https://")[1]
                  : this.selectedDomainWebsite(obj[0].website_id).url.split("https://")[1]
              )
            );
            break;
          case "delivered":
            this.deliveriesSeries.push(
              this.modifyDataForCreatingCharts(
                obj,
                property,
                obj[0].website_id ===
                  this.findDomain(this.$route.params.id).website_id
                  ? this.findDomain(this.$route.params.id).url.split("https://")[1]
                  : this.selectedDomainWebsite(obj[0].website_id).url.split("https://")[1]
              )
            );
            break;
        }
      }
    },
    createRadialBar(data, group, index) {
      this.groups[index] = group;

      this.$set(
        this.subsSeries,
        index,
        this.formatNumber(data[0]["subscribed"])
      );
      this.$set(
        this.unsubsSeries,
        index,
        this.formatNumber(data[0]["unsubscribed"])
      );
    },
    createIndexesForComparison(
      variable,
      group,
      obj,
      property,
      percent = false
    ) {
      //this[variable][group] = this.getSum(array, property, percent);
      this[variable][group] = percent
        ? parseFloat(obj[property]).toFixed(2)
        : obj[property];
    },
    findDomain(id) {
      if (id || id == 0) {
        return this.domains.find((el) => el.id == id) !== undefined
          ? this.domains.find((el) => el.id == id)
          : null;
      }
    },
  },
  watch: {
    domainForComparison: {
      handler(id) {
        if (id) {
          this.groups[0] = this.findDomain(this.$route.params.id).url.split("https://")[1];

          this.groups[1] = this.findDomain(id).url.split("https://")[1];
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
